<template>
    <div>
        <v-container fluid>
            <v-card>
                <v-overlay :value="loading" absolute>
                    <div class="text-center">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            :size="50"
                            class="my-4"
                        ></v-progress-circular>
                        <p class="display-1">{{ $t("Loading") }}</p>
                    </div>
                </v-overlay>
                <v-card-title class="py-3">{{ modalTitle }}</v-card-title>
                <v-card-text class="px-5">
                        <div class="rights_header-buttons mb-2">
                            <v-menu bottom right>
                                <template v-slot:activator="{ on: menu, attrs }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on: tooltip }">
                                            <v-btn
                                                text
                                                small
                                                v-bind="attrs"
                                                v-on="{ ...tooltip, ...menu }"
                                                color="blue-grey"
                                            >
                                                <v-icon large>mdi-history</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ $t('Versions') }}</span>
                                    </v-tooltip>
                                </template>
                                <v-list>
                                    <v-list-item
                                        v-for="(item, i) in versionList"
                                        :key="i"
                                        @click="onVersionChange(item)"
                                    >
                                        <v-list-item-title>{{ `v${item.text}` }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>

                            <v-btn color="secundary" @click.prevent="close">
                                {{ $t("Cancel") }}
                            </v-btn>
                            <v-btn color="primary" @click.prevent="saveAndExit">
                                {{ $t("Save") }}
                            </v-btn>
                        </div>
                    <v-row v-if="rightsItems.length == 0" justify="center" align="center">
                        <v-col cols="1">
                            <v-btn color="primary" prepend-icon="mdi-plus" outlined @click="addContentTypeRights()">
                                {{ $t('Add') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-form>
                        <div v-for="(item, index) in rightsItems" :key="item.uuid">
                            <v-row align="center" class="ma-0 pt-2">
                                <v-col cols="auto" align-self="center" class="py-1 px-2">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" small color="error" icon @click="removeContentTypeRights(item.uuid)">
                                                <v-icon class="pb-2" medium>mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ $t('Delete') }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col align-self="center" class="py-1 px-2">
                                    <v-text-field
                                        readonly
                                        v-model="item.displayConditionStr"
                                        :label="$t('Condition')"
                                        :append-icon="
                                        item.conditionStr == '' ? 'mdi-plus' : 'mdi-pencil'"
                                        @click:append="editCondition(item)"
                                        @input="$v.rightsItems.$touch()"
                                        @blur="$v.rightsItems.$touch()"
                                        dense
                                        class="dense-placeholder-padding"
                                    ></v-text-field>
                                </v-col>
                                <v-col align-self="center" class="py-1 px-2">
                                    <v-select
                                        :label="$t('Role')"
                                        v-model="item.roleTypeID"
                                        :items="rolesList"
                                        item-text="text"
                                        item-value="id"
                                        :error-messages="roleErrors(index)"
                                        @input="$v.rightsItems.$touch()"
                                        @blur="$v.rightsItems.$touch()"
                                        dense
                                    >
                                        <template slot="append-outer">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" color="success" icon @click="onRoleButtonClick" small>
                                                        <v-icon small>mdi-table-plus</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('InsertData') }}</span>
                                            </v-tooltip>
                                        </template>
                                    </v-select>
                                </v-col>
                                <v-col align-self="center" class="py-1 px-2">
                                    <v-select
                                        :label="$t('AccessRight')"
                                        v-model="item.accessRightId"
                                        :items="accessRightsList"
                                        item-text="text"
                                        item-value="id"
                                        :error-messages="accessRightErrors(index)"
                                        @input="$v.rightsItems.$touch()"
                                        @blur="$v.rightsItems.$touch()"
                                        dense
                                    >
                                        <template slot="append-outer">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" color="success" icon @click="onAccessRightButtonClick" small>
                                                        <v-icon small>mdi-table-plus</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('InsertData') }}</span>
                                            </v-tooltip>
                                        </template>
                                    </v-select>
                                </v-col>
                                <v-col align-self="center" class="py-1 px-2">
                                    <v-select :label="$t('DigitalSignature')" v-model="item.digitalSignatureConfigId"
                                        :items="digitalSignaturesList" item-text="text" item-value="id" clearable @input="$v.rightsItems.$touch()"
                                        @blur="$v.rightsItems.$touch()"
                                        dense>
                                        <template slot="append-outer">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" color="success" icon @click="onDigitalSignatureButtonClick" small>
                                                        <v-icon small>mdi-table-plus</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('InsertData') }}</span>
                                            </v-tooltip>
                                        </template>
                                    </v-select>
                                </v-col>
                                <v-col cols="auto" align-self="center" class="py-1 px-2">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" small color="primary" icon @click="addContentTypeRights()">
                                                <v-icon class="pb-2" medium>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ $t('Add') }}</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </div>
                    </v-form>
                    <SearchCriteriaBuilderModal
                        :ref="conditionModalKey"
                        :contentTypeIDs="[contentType.id]"
                        @on-condition-saved="onConditionChanged"
                        :allowEmptyCondition="true"
                        :canUseVariables="false"
                    />
                    <DigitalSignatureModal :ref="digitalSignatureModalKey" @on-item-saved="getDigitalSignatures" />
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>
<script>
import SearchCriteriaBuilderModal from '@/components/search/SearchCriteriaBuilderModal.vue';
import ContentType from '@/ecm/models/contentType/ContentType';
import ContentTypeField from '@/ecm/models/contentType/ContentTypeField';
import ContentTypeRight from '@/ecm/models/contentType/ContentTypeRight';
import ContentTypeService from '@/services/ContentTypeService';
import RoleService from '@/services/RoleService';
import AccessRightService from '@/services/AccessRightService';
import DigitalSignatureService from '@/services/DigitalSignatureService';
import DigitalSignatureModal from '@/components/administration/digitalSignature/DigitalSignatureModal.vue';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import Utils from '@/ecm/common/Utils';

export default {
    name: 'AccessRightsAdministration',
    components: {
        SearchCriteriaBuilderModal,
        DigitalSignatureModal,
    },
    async created() {
        await this.loadContentTypeData();
        this.getContentTypeRights();
        this.getFields();
        this.getRoles();
        this.getAccessRights();
        this.getDigitalSignatures();
        this.$v.$reset();
    },
    async beforeRouteLeave(to, from, next) {
        if (this.$v.rightsItems.$dirty) {
            try {
                const res = await this.unsavedChangesMessageConfirm();
                if (res === 1) {
                    await this.saveAndExit();
                }
                return next();
            } catch (error) {
                return next(false);
            }
        }
        next();
    },
    data() {
        return {
            modal: {
                title: this.$t('ContentTypeAccessRights'),
                key: 'contentTypeRightsModal',
            },
            contentType: new ContentType(),
            conditionModalOpen: false,
            rightsItems: [],
            currentItem: new ContentTypeRight(),
            versionList: [],
            rolesList: [],
            accessRightsList: [],
            digitalSignaturesList: [],
            conditionModalKey: 'conditionModalKey',
            accessRightModalKey: 'accessRightModalKey',
            digitalSignatureModalKey: 'digitalSignatureModalKey',
            loading: true,
            addingButton: false,
        };
    },
    mixins: [validationMixin],
    validations: {
        rightsItems: {
            $each: {
                roleTypeID: { required },
                accessRightId: { required },
            },
        },
    },
    computed: {
        modalTitle() {
            return `${this.modal.title} - ${this.contentType.name} ${this.contentType.version}`;
        },
        conditionModalInstance() {
            return this.$refs[this.conditionModalKey];
        },
        digitalSignatureModalInstance() {
            return this.$refs[this.digitalSignatureModalKey];
        }
    },
    methods: {
        async loadContentTypeData() {
            const id = this.$route.params.id;
            if (id) {
                await ContentTypeService.GetNameAndVersions(id)
                    .then((data) => {
                        if (data === null) {
                            Utils.toast.error(`${this.$t('ItemNotFoundException')} (${this.$t('ContentType')}: ${id})`);
                            this.close();
                        }
                        this.contentType = new ContentType();
                        this.contentType.id = id;
                        this.contentType.name = data.name;
                        this.contentType.version = `v${data.currentVersion}`;
                        this.versionList = data.versions;
                    })
                    .catch((error) => {
                        console.error('Error loading content type data:', error);
                    });
            }
        },
        async unsavedChangesMessageConfirm() {
            return new Promise((resolve) => {
                this.$confirm(this.$t('UnsavedChangesWarning'), {
                    title: this.$t('Confirm'),
                    icon: 'mdi-alert',
                    color: 'warning',
                    buttonTrueText: this.$t('Save'),
                    buttonFalseText: this.$t('Cancel')
                }).then((res) => {
                    resolve(res);
                });
            });
        },
        roleErrors(index) {
            const errors = [];
            if (!this.$v.rightsItems.$each[index].roleTypeID.$dirty)
                return errors;
            !this.$v.rightsItems.$each[index].roleTypeID.required &&
                errors.push(this.$t('RequiredField'));
            return errors;
        },
        onRoleButtonClick() {
            this.addingButton = true;
            this.$router.push('/administration/roles/0');
        },
        onAccessRightButtonClick() {
            this.$router.push('/administration/access-rights/0');
        },
        onDigitalSignatureButtonClick() {
            this.digitalSignatureModalInstance.new();
        },
        accessRightErrors(index) {
            const errors = [];
            if (!this.$v.rightsItems.$each[index].accessRightId.$dirty)
                return errors;
            !this.$v.rightsItems.$each[index].accessRightId.required &&
                errors.push(this.$t('RequiredField'));
            return errors;
        },
        editCondition(item) {
            this.currentItem = item;
            this.conditionModalInstance.edit(item.conditionStr);
        },
        onConditionChanged(condition) {
            this.currentItem.conditionStr = condition.conditionStr;
            this.currentItem.displayConditionStr = condition.displayConditionStr;
        },
        async onVersionChange(version) {
            if (this.contentType.id != version.id) {
                if (this.$v.rightsItems.$dirty) {
                    const res = await this.unsavedChangesMessageConfirm();
                    if (res === 1) {
                        await this.saveContentTypeRights();
                    }
                    this.$v.$reset();
                }
                this.contentType.id = version.id;
                this.contentType.version = `v${version.text}`;
                await this.getContentTypeRights();
                await this.getFields();
            }
        },
        async getContentTypeRights() {
            await ContentTypeService.getRights(this.contentType.id).then(
                (data) => {
                    this.rightsItems = data.map((dto) => new ContentTypeRight(dto));
                }
            );
        },
        async getFields() {
            await ContentTypeService.getFields([this.contentType.id]).then(
                (data) => {
                    this.contentType.fields = data.map(function(dto) {
                        return new ContentTypeField(dto);
                    });
                }
            );
        },
        async getRoles() {
            await RoleService.getList().then((data) => {
                this.rolesList = data;
            });
        },
        async getAccessRights() {
            await AccessRightService.getList().then((data) => {
                this.accessRightsList = data;
            });
        },
        async getDigitalSignatures() {
            await DigitalSignatureService.getList().then((data) => {
                this.digitalSignaturesList = data;
            });
            this.loading = false;
        },
        async saveContentTypeRights() {
            this.loading = true;
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.loading = false;
                return;
            }

            const rights = this.rightsItems.map((item) => item.toDto());
            await ContentTypeService.saveRights(this.contentType.id, rights)
                .then(() => {
                    this.$store.dispatch('account/getUserContentTypes');
                    this.$store.dispatch('account/getUserMenu');
                    Utils.toast.success(this.$t('SavedSuccessfully'));

                    this.$v.$reset();
                }).catch((error) => {
                    console.error('Error saving content type rights:', error);
                }).then(() => {
                    this.loading = false;
                });
        },
        addContentTypeRights() {
            this.rightsItems.push(new ContentTypeRight());
        },
        removeContentTypeRights(uuid) {
            this.rightsItems = this.rightsItems.filter((item) => item.uuid !== uuid);
            this.$v.rightsItems.$touch();
        },
        close() {
            this.$router.push({ name: 'ContentTypeList' });
        },
        async saveAndExit() {
            await this.saveContentTypeRights();
            if (!this.addingButton)
                this.close();
        }
    },
};
</script>
<style>
.rights_header-buttons{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 5px 0px;
}
</style>